import { usePageContext } from 'application/contexts/PageContext';
import { RichText } from 'designsystem/components/1-atoms/RichText';
import { fireAdobeEvent } from 'helpers/adobeEvent';
import React, { useEffect } from 'react';
import { ModuleFeature } from '../DynamicModule';

export const RichTextFeature: React.FC<Content.RichText> = ({ content }) => {
	const { content: rteContent, modals } = content?.properties ?? {};
	const pageContext = usePageContext();
	const modalTracking = (modalName: string) => {
		fireAdobeEvent('modal_click', {
			pageName: pageContext.name,
			modalName: modalName,
		});
	};

	const richTextModals = modals
		? modals?.items?.map((modal) => {
				const { modalId, header, body } = modal?.content?.properties ?? {};
				return {
					modalId,
					header,
					body: body?.items?.map((contentModule, index) => {
						return <ModuleFeature contentModule={contentModule} key={index} additionalProps={{ noBackground: true }} />;
					}),
				};
		  })
		: null;

	useEffect(() => {
		const anchor = window.location.hash && document.getElementById(window.location.hash.slice(1));
		if (anchor) anchor.scrollIntoView();
	}, [rteContent]);

	return <RichText content={rteContent?.markup} modals={richTextModals} modalTrackingCallback={modalTracking} />;
};
